module.exports = __webpack_public_path__ + "img/ep-flamme.c98f1b76.jpg";